import React from "react"

import * as sheetHeroStyles from "../../styles/beyond_spreadsheet/SheetHero.module.css"

import WPImage from "../_base/WPImage"

export default function SheetHero(props) {
  const { content } = props

  return (
    <>
      <div
        className={`row ${props.className} ${sheetHeroStyles.wrapper}`}
      >
        <div className={`col-12 ${sheetHeroStyles.wrapperImage}`}>
         
          <WPImage
            holder={content}
            selector={`media-asset`}
            className={`${sheetHeroStyles.image}`}
          />
        </div>
      </div>
    </>
  )
}
